import { css } from 'emotion'
import { Colors, Label, SearchLabel } from './..'

//FORM
export const FieldStyle = (isEmpty, isBig) => css({
  position: 'relative',
  'input[type="text"], input[type="password"], input[type="email"], textarea, input[type="date"]': {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    margin: '0.3125rem 0px',
    padding: '0.3125rem 0',
    background: 'none',
    border: 0,
    borderBottom: `1px solid ${Colors.lightGrey}`,
    WebkitAppearance: 'none',
    '@media (min-width: 1024px)': {
      padding: '0.625rem 0px',
    },
    
    '& + label': {
      position: 'absolute',
      top: isEmpty ? '50%' : 0,
      left: 0,
      transform: isEmpty ? 'translate(0, -50%)' : 'scale(0.5) translateY(-15px)',
      transformOrigin: 'top left',
      color:  Colors.lightGrey,
      zIndex: isEmpty ? 0 : 1,
      transition: `all ${isEmpty ? '400ms' : '200ms'} ease`,
      transitionDelay: isEmpty ? '200ms' : 0,
      ...Label,
      fontWeight: isEmpty ? 200 : 800,
      whiteSpace: 'nowrap',
      'svg':{
        fill: Colors.lightGrey,
      }
    },
    '&:focus +label': {
      color: 'black',
      'svg':{
        fill: 'black'
      }
    }
  },
}, {
  'input[type="text"], input[type="password"], input[type="email"], textarea, input[type="date"]': {
    ...Label,
  }
}, isBig && {
  'input[type="text"], input[type="password"], input[type="email"], textarea , input[type="date"]': {
    ...SearchLabel,
    fontWeight: 200,
    padding: '1rem 2rem 1rem 0',
    '& + label': {
      ...SearchLabel,
      fontWeight: 200,
      opacity: isEmpty ? 1 : 0.5,
    }
  }
})

export const TextareaStyle = (isEmpty) => css({
  'textarea': {
    height: 100,
    '@media (min-width: 1024px)':{
      height: 200
    },
    '& + label': {
      top: '1rem',
      transform: `scale(${isEmpty ? 1 : 0.5}) translateY(${isEmpty ? 0 : -20}px)`,
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/fields.js